import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";
import Crypt from '../lib/Crypt';
import swal from 'sweetalert';
import C from '../lib/Config';

const preConditionListArr = [
    { key: Crypt.getUniqueKey('0'), id: 'GE', label: 'Greater Than' },
    { key: Crypt.getUniqueKey('1'), id: 'LE', label: 'Less Than' }, 
]
export default class PreConditionMSTPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportParam: '',
            reportParameterArr: [],
            preConditionValue: '',
            preConditionListArr: [],
            preConditionList: '',
            reportParamName: '',
            preConditionListName: '',
            protocolpreconditionsId: 0
 
        }; 
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.getAllReportParameters();  
    }
    handleChange(event){
        if(event.target.name === 'reportParam'){
            this.setState({reportParam: event.target.value});
            this.setState({reportParamName: event.target.options[event.target.selectedIndex].text});
        }
        if(event.target.name === 'preConditionList'){
            this.setState({preConditionList: event.target.value});
            this.setState({preConditionListName: event.target.options[event.target.selectedIndex].text});
        }
        if(event.target.name === 'preConditionValue'){
            this.setState({preConditionValue: event.target.value});
        } 
    }
    // validatePreCondition(){
    //     let formIsValid = true;
    //     let errors = {};
    //     if (this.state.reportParam === "" || this.state.reportParam === null) {
    //         errors["reportParam"] = "Please enter first name";
    //         formIsValid = false;
    //     }
    //     if (this.state.preConditionList === "" || this.state.preConditionList === null) {
    //         errors["preConditionList"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     }
    //     if (this.state.preConditionValue === "" || this.state.preConditionValue === null) {
    //         errors["preConditionValue"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     } 
    //     this.setState({protocol: errors });
    //     return formIsValid;
    // }
    savePreCondition(event){
        let data = { 
            reportParamsID: this.state.reportParam,
            reportParamsNames: this.state.reportParamName,
            preConditionListsID: this.state.preConditionList,
            preConditionListsNames: this.state.preConditionListName,
            preConditionValues: this.state.preConditionValue,
            protocolpreconditionsId: this.state.protocolpreconditionsId
        }
        this.props.savePreConditionMST(data); 
    }
     
    getAllReportParameters() {
        return fetch(C.getUrl() + '/reportParamMst/findAll')
            .then(res => res.json())
            .then(res => {
                if (!res || !res.message) return;
                let resObj = JSON.parse(res.message);
                if (!Array.isArray(resObj)) return;
                var arr = [];
                resObj.forEach(function (d) {
                    arr.push({ id: d.reportParamId, name: d.reportParamName });
                });
                this.setState({ reportParameterArr: arr });
            })
            .catch(err => {
                console.error("Error fetching report parameters: " + err);
            });
    }
    render() {
        const { showPreConditionMSTPopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { reportParameterArr } = this.state;
        return (
            <div>
                <Modal id="report" show={showPreConditionMSTPopup} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Pre-Condition Master</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Report Paramter</Form.Label>
                                        <Form.Control as="select" id="" name='reportParam' value={this.state.reportParam} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Report Parameter -</option>
                                            {
                                                reportParameterArr.map((item, i) => {
                                                        return (
                                                            <option key={item.id} value={item.id}>{`${item.name}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>List</Form.Label>
                                        <Form.Control as="select" id="" name='preConditionList' value={this.state.preConditionList} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select List -</option>
                                            {
                                                preConditionListArr.map((item, i) => {
                                                        return (
                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>Value</Form.Label>
                                        <Form.Control type='number' placeholder='' name='preConditionValue' onChange={this.handleChange} />
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary" onClick={this.savePreCondition.bind(this)}>
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Add 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}